import {UyapRequest} from "./UyapRequest";
import {MDB} from "../MDB";
import {uyapEngelDurdurmaliMi} from "../UyapEngeli";
import app from "@/main";

export interface AvukatSorgulamaTalep {
    tcKimlikNo: string,
    baroNo: string,
    tbbNo: string,
    ilKodu: string,
    baroKodu: string,
}

export interface AvukatSorgulamaCevap {
    ad: string,
    soyad: string,
    avukatId: number,
    tcKimlikNo: number,
    isKamuAvukati: boolean,
    durum: number
}

export default class AvukatSorgulama extends UyapRequest<AvukatSorgulamaTalep, AvukatSorgulamaCevap> {
    delayTime = 0;

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "avukatsorgulama_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    async parse(data: any): Promise<AvukatSorgulamaCevap> {
        return data;
    }

    async recursive(data: AvukatSorgulamaTalep): Promise<AvukatSorgulamaCevap> {
        this.delayTime = 3000;
        data.tcKimlikNo = data.tcKimlikNo.toString().trim();
        console.log("AvukatSorgulamaTalep DATA ==", data)
        let rejectMessage = {"message": "Vekil avukat bulunamadı"};
        
        if (app.$uyapHelper.tcKimlikNoValidate(data.tcKimlikNo)) {
            try {
                let avukat = await this.run({
                    tcKimlikNo: data.tcKimlikNo,
                    baroNo: "",
                    tbbNo: "",
                    ilKodu: "",
                    baroKodu: ""
                })
                return avukat;
            } catch (e) {
                // UYAP engeli "avukat bulunamadı"ya dönüşmez (DEV-3572)
                if (uyapEngelDurdurmaliMi(e)) throw e;
                // continue to next check
            }
        }
        
        if (data.tbbNo != "") {
            try {
                let avukat = await this.run({
                    tcKimlikNo: "",
                    baroNo: "",
                    tbbNo: data.tbbNo,
                    ilKodu: "",
                    baroKodu: ""
                })
                return avukat;
            } catch (e) {
                // UYAP engeli "avukat bulunamadı"ya dönüşmez (DEV-3572)
                if (uyapEngelDurdurmaliMi(e)) throw e;
                // continue to next check
            }
        }
        
        if (data.baroNo != "" && data.ilKodu != "") {
            let barolar = MDB.baroKodlari.filter((i) => i.ilKodu == data.ilKodu);
            for (const baro of barolar) {
                try {
                    let requestPayload = {
                        tcKimlikNo: "",
                        baroNo: data.baroNo,
                        tbbNo: "",
                        baroKodu: baro.baroKodu,
                        ilKodu: data.ilKodu
                    }
                    let avukat = await this.run(requestPayload)
                    if (avukat.ad && avukat.ad != "")
                        return avukat;
                } catch (e) {
                    if (uyapEngelDurdurmaliMi(e)) throw e;
                    console.log("CATCH ==== BARKO KODI", e);
                    // continue to next baro
                }
            }
        }
        
        throw rejectMessage;
    }

    getMockResponse(): any {
        return {"ad":"NİHAN","soyad":"ERDOĞAN","avukatId":1746688,"tcKimlikNo":"14537825364","isKamuAvukati":false,"durum":0};
    }

    getUrl(): string {
        return this.ImzaClientAddr + "avukat_sorgulama.ajx";
    }

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Avukat sorgulanıyor...";
    }
}


